import axios from "axios";
import { idText } from "typescript";
import { ServerSideTypes } from "../component/common/OperationCommonTypes";
import ChecklistType from "../component/Vehicle/ChecklistType";
import OperationTypes from "../types";

export { vehicleActions };

var qs = require('qs');

axios.defaults.withCredentials = true;

export interface ICheckComment {
    id: number,
    note: string,
    createDataTime: string
}

function vehicleActions() {
  const baseUrl = ``;
  return {
    getBrands,
    getModels,
    getCarSegment,
    getCarClass,
    getSipp,
    getAcriss,
    getMainTenanceById,
    updateVehicle,
    getAllTireType,
    getVehicleById,
    exportDataVehicle,
    getAllVehicle,
    getDefaultEquipment,
    getActualEquipment,
    getExtraEquipment,
    downloadImage,
    downloadTemplate,
    uploadPriceList,
    vehicleChecklist,
    firstFuelingData,
    downloadFuelingData,
    getEditableVehicle,
    getVehicleCheckComments,
    getReasonCodes,
  };

  async function getBrands(tenant: string) {
    return axios.get(`${baseUrl}/masterdatavehicle/brand/all`, {
      params: { tenant: tenant },
    });
  }
  
  async function getReasonCodes(tenant: string) {
    const fixedParams = { valid: true, pageNumber: 0, pageSize: 100000 };
    return axios.get<ServerSideTypes.IResult<OperationTypes.Domain>>("masterdatavehicle/statusreason", {
      params: {
        tenant: tenant,
        valid: fixedParams.valid,
        pageNumber: fixedParams.pageNumber,
        pageSize: fixedParams.pageSize,
      },
    }).then((response) => {
      return response.data.content;
    });
  }

  async function getEditableVehicle(tenant: string, id: number) {
    return axios
      .get(`${baseUrl}/masterdatavehicle/vehicle/${id}/editable`, {
        params: { tenant: tenant },
      })
      .then((response) => response.data);
  }

  async function downloadTemplate(tenant: string) {
    return axios.get(
      `${baseUrl}/masterdatavehicle/unavailability/downloadExcelTemplate`,
      {
        params: {
          tenant: tenant,
        },
        responseType: "arraybuffer",
      }
    );
  }

  async function uploadPriceList(tenant: string, fileName: FormData) {
    return axios.post(
      `${baseUrl}/masterdatavehicle/unavailability/massiveLoadVehicle`,
      fileName,
      {
        params: { tenant: tenant },
        responseType: "arraybuffer",
        headers: { "Access-Control-Allow-Origin": true },
      }
    );
  }

  async function getModels(tenant: string) {
    return axios.get(`${baseUrl}/masterdatavehicle/model/all`, {
      params: { tenant: tenant },
    });
  }
  async function getCarSegment(tenant: string) {
    return axios.get(`${baseUrl}/masterdatavehicle/carsegment/all`, {
      params: { tenant: tenant },
    });
  }
  async function getCarClass(tenant: string) {
    return axios.get(`${baseUrl}/masterdatavehicle/carclass/all`, {
      params: { tenant: tenant },
    });
  }

  async function getSipp(tenant: string) {
    return await axios
      .get("masterdatavehicle/customacriss/all", {
        params: { tenant: tenant },
      })
      .then((response) => response.data);
  }

  async function getAcriss(tenant: string) {
    return await axios
      .get("masterdatavehicle/acriss/all", {
        params: { tenant: tenant },
      })
      .then((response) => response.data);
  }

  async function updateVehicle(id: number, tenant: string, editVehicle: any) {
    return axios.put(
      `${baseUrl}/masterdatavehicle/vehicle/${id}`,
      editVehicle,
      { params: { tenant: tenant } }
    );
  }
  async function getMainTenanceById(
    tenant: string,
    vehicleId: any,
    maintenaceDataFrom?: any,
    maintenaceDataTo?: any
  ) {
    return axios.get(
      `${baseUrl}/masterdatavehicle/maintenance/vehicle/${vehicleId}`,
      {
        params: {
          tenant: tenant,
          maintenaceDataFrom: maintenaceDataFrom,
          maintenaceDataTo: maintenaceDataTo,
        },
      }
    );
  }
  async function getAllTireType() {
    return axios.get(`${baseUrl}/masterdatavehicle/tiretype/all`);
  }
  async function getVehicleById(tenant: string, vehicleid: any) {
    return axios.get(`${baseUrl}/masterdatavehicle/vehicle/${vehicleid}`, {
      params: { tenant: tenant },
    });
  }
  async function exportDataVehicle(
    lang: string,
    tenant: string,
    brandId?: number,
    modelId?: number,
    carSegmentId?: number,
    carClassId?: number,
    acrissId?: number,
    customAcrissId?: number,
    vin?: string,
    plate?: string,
    inFleet?: boolean,
    vehicleStatus?: string,
    currentTireType?: string,
    expectedSaleDateFrom?: string | null,
    expectedSaleDateTo?: string | null,
    imeiPrimary?: string,
    imeiSecondary?: string,
    firstFuelingDone?: boolean | null,
    enginePowerGroupCodes?: any | null,
    reasonCode?: [] | null,
    ownership?: string,
    extColor?: string | null,
    registrationDateFrom?: string | null,
    registrationDateTo?: string | null,
    realDeliveryDateFrom?: string | null,
    realDeliveryDateTo?: string | null,
    keyless?: boolean
  ) {
    const params = {
      tenant: tenant,
      brandId: brandId,
      modelId: modelId,
      carSegmentId: carSegmentId,
      carClassId: carClassId,
      acrissId: acrissId,
      customAcrissId: customAcrissId,
      vin: vin,
      plate: plate,
      inFleet: inFleet,
      vehicleStatus: vehicleStatus,
      currentTireType: currentTireType,
      expectedSaleDateFrom: expectedSaleDateFrom,
      expectedSaleDateTo: expectedSaleDateTo,
      imeiPrimary: imeiPrimary,
      imeiSecondary: imeiSecondary,
      firstFuelingDone: firstFuelingDone,
      enginePowerGroupCodes: enginePowerGroupCodes,
      statusReasons: reasonCode,
      ownership,
      extColor,
      registrationDateFrom,
      registrationDateTo,
      realDeliveryDateFrom,
      realDeliveryDateTo,
      keyless
    };
    return axios.get(`${baseUrl}/masterdatavehicle/vehicle/excel`, {
      params: params,
      paramsSerializer: function(params) {
          return qs.stringify(params, {arrayFormat: 'repeat'})
       },
      responseType: "arraybuffer",
      headers: {
        "Access-Control-Allow-Origin": true,
        langFe: lang,
      },
    });
  }

  async function getAllVehicle(
    tenant: string,
    pageSize: number,
    pageNumber: number,
    sortCode?: string,
    sortDirection?: string,
    brandId?: number,
    modelId?: number,
    carSegmentId?: number,
    carClassId?: number,
    acrissId?: number,
    customAcrissId?: number,
    vin?: string,
    plate?: string,
    imeiPrimary?: string,
    imeiSecondary?: string,
    currentTireType?: string,
    expectedSaleDateFrom?: string | null,
    expectedSaleDateTo?: any,
    inFleet?: boolean,
    vehicleStatus?: string,
    firstFuelingDone?: boolean | null,
    enginePowerGroupCodes?: any | null,
    reasonCode?: [] | null,
    ownership?: string,
    extColor?: string | null,
    registrationDateFrom?: string | null,
    registrationDateTo?: string | null,
    realDeliveryDateFrom?: string | null,
    realDeliveryDateTo?: string | null,
    keyless?: boolean
  ) {
    const params = {
      tenant: tenant,
      pageSize: pageSize,
      pageNumber: pageNumber,
      sortCode: sortCode,
      sortDirection: sortDirection,
      brandId: brandId,
      modelId: modelId,
      carSegmentId: carSegmentId,
      carClassId: carClassId,
      acrissId: acrissId,
      customAcrissId: customAcrissId,
      vin: vin,
      plate: plate,
      imeiPrimary: imeiPrimary,
      imeiSecondary: imeiSecondary,
      currentTireType: currentTireType,
      expectedSaleDateFrom: expectedSaleDateFrom,
      expectedSaleDateTo: expectedSaleDateTo,
      inFleet: inFleet,
      vehicleStatus: vehicleStatus,
      firstFuelingDone: firstFuelingDone,
      enginePowerGroupCodes: enginePowerGroupCodes,
      statusReasons: reasonCode,
      ownership,
      extColor,
      registrationDateFrom,
      registrationDateTo,
      realDeliveryDateFrom,
      realDeliveryDateTo,
      keyless
    };
    return axios.get(`${baseUrl}/masterdatavehicle/vehicle`, {
      params: params,
      paramsSerializer: function(params) {
          return qs.stringify(params, {arrayFormat: 'repeat'})
       },
    });
  }

  async function getDefaultEquipment(tenant: string, payload: any) {
    return new Promise(function (resolve, reject) {
      axios
        .get<ServerSideTypes.IResult<any>>(
          `${baseUrl}/masterdatavehicle/vehicle/${payload.id}/equipment/default`,
          { params: { tenant, ...payload } }
        )
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error.response);
        });
    });
  }

  async function getActualEquipment(tenant: string, payload: any) {
    return new Promise(function (resolve, reject) {
      axios
        .get<ServerSideTypes.IResult<any>>(
          `${baseUrl}/masterdatavehicle/vehicle/${payload.id}/equipment/actual`,
          { params: { payload } }
        )
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error.response);
        });
    });
  }
  async function getExtraEquipment(tenant: string, payload: any) {
    return new Promise(function (resolve, reject) {
      axios
        .get<ServerSideTypes.IResult<any>>(
          `${baseUrl}/masterdatavehicle/vehicle/${payload.id}/equipment/extra`,
          { params: { tenant, ...payload } }
        )
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error.response);
        });
    });
  }

  async function downloadImage(
    id: number,
    equipmentId: number,
    tenant: string
  ) {
    console.log(tenant, "tenant");
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${baseUrl}/masterdatavehicle/vehicle/${id}/equipment/${equipmentId}/image`,
          {
            params: { tenant },
            responseType: "arraybuffer",
          }
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  function vehicleChecklist(id: number, tenant: string) {
    return axios
      .get<ChecklistType.VehicleCheckListType>(
        `/masterdatavehicle/${id}/vehiclechecklist`,
        {
          params: { tenant: tenant },
        }
      )
      .then((response) => response.data);
  }

  function firstFuelingData(id: number, tenant: string) {
    return axios
      .get(`masterdatavehicle/firstfueling/${id}/getVehicleFirstFuelingById`, {
        params: { tenant: tenant },
      })
      .then((response) => response.data);
  }

  function downloadFuelingData(id: number, tenant: string) {
    return axios.get(
      `masterdatavehicle/firstfueling/${id}/getFirstFuelReceipt`,
      {
        params: { tenant: tenant },
        responseType: "arraybuffer",
      }
    );
  }

  function getVehicleCheckComments(tenant: string, id: number, params: ServerSideTypes.IParams) {
    return axios.get<ServerSideTypes.IResult<ICheckComment>>(
      `/masterdatavehicle/vehicle/${id}/equipment/checkcomment/page`,
      {
        params: {
          tenant: tenant,
          ...params,
        }
      }
    )
    .then((response) => response.data);
  }
}
